export const project = {
  comments: 'Bemerkungen',
  projectDetails: 'Projektdetails',
  quoteType: 'Offertentyp',
  appointment: 'Termin',
  projectType: 'Projekttyp',
  basin: 'Lavabo',
  color: 'Farbe',
  shape: 'Form',
  style: 'Stil',
  standard: 'Standard',
  furnishing: 'Ausstattung',
  wallMaterial: 'Wandmaterial',
  floorMaterial: 'Bodenmaterial',
  realEstateType: 'Gebäudetyp',
  systemType: 'Systemtyp',
  area: 'Fläche',
  quoteComments: 'Offerten Bemerkungen',
  focus: 'Schwerpunkt',
  frame: 'Rahmen',
  alarmEvent: 'Auslöser',
  alarmType: 'Alarmanlagen-Typ',
  amount: 'Menge',
  amountRooms: 'Anzahl Räume',
  amountPersons: 'Anzahl Personen',
  assemblingType: 'Zu montierendes Objekt',
  roomHeight: 'Raumhöhe',
  glazing: 'Verglasung',
  product: 'Produkt',
  shutter: 'Rollladen',
  swissness: 'Swissness',
  amountSkyLight: 'Anzahl Dachfenster',
  shutterDesired: 'Rollladen gewünscht',
  amountFrontDoor: 'Anzahl Haustüren',
  amountSlideDoor: 'Anzahl Hebeschiebetüren',
  amountFrenchDoor: 'Anzahl Fenstertüren',
  amountOtherDoors: 'Anzahl Sonstige',
  amountDefaultWindow: 'Anzahl Standardfenster',
  mode: 'Betriebsart',
  persons: 'Personen',
  service: 'Dienstleistung',
  livingArea: 'Wohnfläche',
  vehicle: 'Fahrzeug',
  material: 'Material',
  garageDoor: 'Garagentor',
  kind: 'Art',
  household: 'Haushalt',
  gates: 'Tore',
  length: 'Länge',
  room: 'Raum',
  roomType: 'Raumtyp',
  activity: 'Tätigkeit',
  size: 'Grösse',
  carType: 'Fahrzeugtyp',
  approval: 'Bewilligung',
  subFloor: 'Untergrund',
  equipment: 'Ausstattung',
  roofShape: 'Dachform',
  speciality: 'Spezielles',
  heatingCost: 'Heizkosten',
  heatingType: 'Heizungstyp',
  constructionYear: 'Baujahr',
  currentHeatingTypeType: 'Aktueller Heizungstyp',
  currentHeatingType: 'Aktueller Heizungstyp',
  currentWaterConditioning: 'Aktuelle Wasseraufbereitung',
  newWaterConditioning: 'Neue Wasseraufbereitung',
  distributionSystem: 'Verteilsystem',
  floors: 'Stockwerke',
  monumentProtection: 'Denkmalschutz',
  houseLength: 'Hauslänge',
  plantSystem: 'Anlagentyp',
  roofMaterial: 'Dachmaterial',
  cardinalPoint: 'Himmelsrichtung',
  type: 'Typ',
  craftsmenAndQuotes: 'Handwerker und Offerten',
  addOwnCraftsman: 'Eigenen Handwerker hinzufügen',
  call: 'Anruf',
  searchingFor3CraftsMen: '3 Handwerker werden gesucht',
  searchingFor2CraftsMen: '2 weitere Handwerker werden gesucht',
  searchingFor1CraftsMan: '1 Handwerker wird noch gesucht',
  addYourOwnCraftsman: 'Erstellen sie einen Handwerker und laden sie ihre Offerte hoch',
  noToDos: 'Sie haben noch keine To-do’s',
  noDocumentation: 'Sie haben noch keine Dokumentation',
  noDocuments: 'Sie haben noch keine Dokumente hochgeladen',
  createToDo: 'To-do erstellen',
  createDocumentation: 'Dokumentation hochladen',
  uploadDocument: 'Dokument hochladen',
  task: 'Aufgabe',
  address: 'Anschrift',
  uploadQuote: 'Aktualisieren',
  bannerImage: 'Bild eines Handwerkers',
  createCraftsmanAndQuoteErrorToastText:
    'Beim Erstellen ihres Handwerkers ist ein Fehler aufgetreten.',
  noQuotes: 'Es sind noch keine Offerten vorhanden.',
  funding: 'Finanzierung',
  features: 'Besonderheiten',
  showMore: 'Mehr Anzeigen',
  showLess: 'Weniger Anzeigen',
  age: 'Alter',
  mainWork: 'Hauptarbeit',
  additionalWork: 'Zusätzliche Arbeiten',
  width: 'Breite',
  location: 'Einsatzort',
  mounting: 'Montageart',
  operation: 'Betriebsart',
  quantity: 'Anzahl',
  parkingType: 'Parkplatztyp',
  circulationPump: 'Pumpe vorhanden',
  installationType: 'Installationsart',
  powerSupply: 'Energieanschluss vorhanden',
  projectDetailInformation:
    'Die Projektdetails können nicht verändert werden. Bitte besprechen Sie Anpassungen direkt mit ihren Handwerkern.',
  projectNameUpdateError:
    'Leider konnte der Name nicht geändert werden. Versuchen Sie es später erneut.',
  noNotes: 'Sie haben noch keine Notizen erfasst',
  createNote: 'Notiz erfassen',
  createAppointment: 'Termin erstellen',
  noAppointments: 'Sie haben noch keine Termine erfasst',
  devices: 'Geräte',
  hob: 'Kochfeld',
}

export const createCraftsmanAndQuoteModal = {
  title: 'Handwerker hinzufügen',
  buttonText: 'Hinzufügen',
  craftsman: 'Handwerker',
  quote: 'Offerte',
  chooseExistingCraftman: 'Einen bestehenden Handwerker auswählen',
  createNewCraftsman: 'Erstelle einen neuen Handwerker',
  pleaseUploadQuote: 'Bitte laden sie die Offerte vom Handwerker hoch',
  uploadNewQuote: 'Neue Offerte hochladen',
  errorText: 'Ihre Offerte konnte nicht bearbeitet werden',
  deleteQuote: 'Offerte löschen',
  deleteText: 'Sind Sie sicher, dass Sie diese Offerte löschen wollen?',
  deleteQuoteButtonText: 'Offerte löschen',
  deleteErrorText: 'Offerte konnte nicht gelöscht werden',
}

export const createNoteModal = {
  title: 'Notiz erstellen',
  notePlaceholder: 'Notiz',
  errorToastText: 'Notiz konnte nicht erstellt werden.',
}
